import { render, staticRenderFns } from "./orgao.vue?vue&type=template&id=58432c64"
import script from "./orgao.vue?vue&type=script&lang=js"
export * from "./orgao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports